import axios, { AxiosResponse } from 'axios';
import { message } from 'antd';
import apiUrl from 'helpers/apiUrl';
import moment from 'moment';

const getKnowledgeRequest = async (): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/fertilization`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response: AxiosResponse<{ code: number; message: string }>) => {
      if (response?.data) {
        return response.data;
      }
    });
};

const savePlantsRequest = async (data: { id: number }): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .put(
      `${apiUrl()}backoffice/fertilization/${data.id}`,
      {
        data,
      },
      {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(<string>tokenString)?.accessToken
          }`,
        },
      }
    )
    .then(() => {
      message.success('Pozytywnie zapisano');
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

const getSpecificKnowledgeRequest = async (id: string): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/fertilization/${id}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      const { data } = response;
      if (data) {
        return data;
      }
    })
    .catch((e) => {
      message.error(e.message);
    });
};

const getSpecificPlantScheduleRequest = async (id: string): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/fertilization/schedule/${id}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      const { data } = response;
      if (data) {
        return data;
      }
    })
    .catch((e) => {
      message.error(e.message);
    });
};

const getPlantsScheduleRequest = async (): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/fertilization/schedule`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      const { data } = response;
      if (data) {
        return data;
      }
    })
    .catch((e) => {
      message.error(e.message);
    });
};

const saveKnowledgeRequest = async (data: { id: number }): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .put(
      `${apiUrl()}backoffice/knowledge/${data.id}`,
      {
        data,
      },
      {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(<string>tokenString)?.accessToken
          }`,
        },
      }
    )
    .then(() => {
      message.success('Pozytywnie zapisano');
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

const savePlantScheduleRequest = async (data: { id: number }): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .put(
      `${apiUrl()}backoffice/fertilization/schedule/${data.id}`,
      {
        data,
      },
      {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(<string>tokenString)?.accessToken
          }`,
        },
      }
    )
    .then(() => {
      message.success('Pozytywnie zapisano');
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

const removeSpecificKnowledgeRequest = async (idNews: number): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios.delete(`${apiUrl()}backoffice/fertilization/${idNews}`, {
    headers: {
      Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
    },
  });
};

export const removeSpecificFertilizationScheduleRequest = async (idNews: number): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios.delete(`${apiUrl()}backoffice/fertilization/schedule/${idNews}`, {
    headers: {
      Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
    },
  });
};

const createFertilizationRequest = async (data: {
  dateAdd: moment.MomentInput;
  name: string;
  intro: string;
}): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .post(`${apiUrl()}backoffice/fertilization`, data, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then(() => {
      message.success('Pozytywnie utworzono element');
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

const createFertilizationScheduleRequest = async (data: {
  dateAdd: moment.MomentInput;
  name: string;
  intro: string;
}): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .post(`${apiUrl()}backoffice/fertilization/fertilization-schedule`, data, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then(() => {
      message.success('Pozytywnie utworzono element');
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

export {
  getKnowledgeRequest,
  removeSpecificKnowledgeRequest,
  getSpecificKnowledgeRequest,
  saveKnowledgeRequest,
  createFertilizationRequest,
  getPlantsScheduleRequest,
  savePlantsRequest,
  savePlantScheduleRequest,
  getSpecificPlantScheduleRequest,
  createFertilizationScheduleRequest,
};
